import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { Act1, Act2, Act3 } from 'game/scenes';
import ROUTES from 'constants/ROUTES';

import GameService from 'services/Game.service';
import LandbotService from 'services/Landbot.service';
import VariablesService from 'services/Variables.service';
import { Layout, Game, Landbot } from 'components';

export default function GamePage() {
  return (
    <GameService>
      <LandbotService>
        <VariablesService>
          <Layout>
            <Switch>
              <Route exact path={ROUTES.TEST.ACT_1}>
                <Landbot
                  key="landbot_1"
                  mode="click"
                  config={{
                    configUrl:
                      'https://chats.landbot.io/v2/H-737659-KFM92QCM2FHAXX5P/index.json',
                  }}
                />
                <Game
                  key="game_1"
                  config={{
                    scene: [Act1],
                    physics: {
                      arcade: {
                        debug: true,
                      },
                    },
                  }}
                />
              </Route>
              <Route exact path={ROUTES.TEST.ACT_2}>
                <Landbot
                  key="landbot_2"
                  mode="click"
                  config={{
                    configUrl:
                      'https://chats.landbot.io/v2/H-737709-RUCBCRK6SI07R76X/index.json',
                  }}
                />
                <Game
                  key="game_2"
                  config={{
                    scene: [Act2],
                    physics: {
                      arcade: {
                        debug: true,
                      },
                    },
                  }}
                />
              </Route>
              <Route exact path={ROUTES.TEST.ACT_3}>
                <Landbot
                  key="landbot_3"
                  mode="click"
                  config={{
                    configUrl:
                      'https://chats.landbot.io/v2/H-737738-LX31FGCGOS15AYAK/index.json',
                  }}
                />
                <Game
                  key="game_3"
                  config={{
                    scene: [Act3],
                    physics: {
                      arcade: {
                        debug: true,
                      },
                    },
                  }}
                />
              </Route>
            </Switch>
          </Layout>
        </VariablesService>
      </LandbotService>
    </GameService>
  );
}
